import { getElementChild, getElements } from '../Utility/Dom'

class EventDetails {
  readonly items: [] | NodeListOf<HTMLElement> = []

  constructor() {
    this.items = getElements('events-details')
  }

  init(): void {
    this.addEvents()
  }

  private addEvents(): void {
    this.items.forEach((item: HTMLElement): void => {
      const toggle = getElementChild(item, 'events-details-toggle')
      const body = getElementChild(item, 'events-details-body')

      if (toggle === null || body === null) return

      toggle.addEventListener('click', (): void => {
        const isOpen = item.classList.toggle('is-open')
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false')

        if (isOpen) {
          body.removeAttribute('inert')
        } else {
          body.setAttribute('inert', '')
        }
      })
    })
  }
}

const eventDetails = new EventDetails()
eventDetails.init()
